import {generateRandomId} from 'utils';

function updateCartCountElements(items) {
  const cartItemCountElements = document.querySelectorAll('[data-item-count]');

  const giftPackageProductId = window.theme.settings.gift_package_product_id;

  const itemsCount = items.reduce((acc, item) => {
    // Exclude gift package products
    if (item.id === giftPackageProductId) return acc;
    // For anam bundles, only count the parent product
    if (item.properties.anam_id && !item.properties._is_anam_parent) return acc;

    return acc + item.quantity;
  }, 0);

  cartItemCountElements.forEach((element) => {
    element.setAttribute('data-item-count', itemsCount);
  });
}

function setSubmitterLoadingState(element, loadingText) {
  if (!element) return;

  const button = element;

  // Either change the text or display a loading state
  if (loadingText) {
    button.innerText = loadingText;
  } else {
    button.classList.add('loading');
  }

  button.disabled = true;
}

function restoreSubmitterState(element, originalText, loadingText) {
  if (!element) return;

  const button = element;

  if (originalText && loadingText) {
    button.innerText = originalText;
  } else {
    button.classList.remove('loading');
  }

  button.disabled = false;
}

async function getCart() {
  try {
    const response = await fetch(window.routes.cart_url);
    if (!response.ok) throw new Error();

    const cart = await response.json();
    if (!cart) throw new Error();

    updateCartCountElements(cart.items);

    // Generic event - Used to update data like cart count etc..
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
        },
      })
    );

    return cart;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function manageCartOperations(url, event, formData) {
  const form = event.target.closest('form');
  if (!form) throw new Error();

  // Not enough support yet for event.submitter
  const button = event.submitter || form.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g. sticky button)
  const originalButtonText = button?.innerText;
  const loadingTextAttribute = button?.getAttribute('data-loading-text');

  setSubmitterLoadingState(button, loadingTextAttribute);

  const finalFormData = formData || new FormData(form);

  // Generate a unique id for each item to ensure it is added as a separate line item in the cart.
  if (!finalFormData.has('properties[_unique_id]')) {
    finalFormData.append('properties[_unique_id]', generateRandomId());
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: finalFormData,
    });
    if (!response.ok) throw new Error();

    const data = await response.json();
    if (!data) throw new Error();

    await getCart();

    restoreSubmitterState(button, originalButtonText, loadingTextAttribute);

    window.theme.modals.cart.open();

    return data;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function addToCart(event, formData) {
  event.preventDefault();

  const url = window.routes.cart_add_url;
  await manageCartOperations(url, event, formData);
}

// To update the cart's line item quantities, note, or attributes
async function updateItem(event, formData) {
  event.preventDefault();

  const url = window.routes.cart_update_url;
  await manageCartOperations(url, event, formData);
}

// To change the quantity, properties, and selling_plan
async function changeItem(event, formData) {
  event.preventDefault();

  const url = window.routes.cart_change_url;
  await manageCartOperations(url, event, formData);
}

async function removeItem(event) {
  event.preventDefault();

  const url = window.routes.cart_change_url;
  await manageCartOperations(url, event);
}

// Anam specific
async function manageAnamCartOperations(url, event, serializedData) {
  const form = event.target.closest('form');
  if (!form) throw new Error();

  // Not enough support yet for event.submitter
  const button = event.submitter || form.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g. sticky button)
  const originalButtonText = button?.innerText;
  const loadingTextAttribute = button?.getAttribute('data-loading-text');

  setSubmitterLoadingState(button, loadingTextAttribute);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializedData,
    });
    if (!response.ok) throw new Error();

    const data = await response.json();
    if (!data) throw new Error();

    await getCart();

    restoreSubmitterState(button, originalButtonText, loadingTextAttribute);

    window.theme.modals.cart.open();

    return data;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function addAnamToCart(event, serializedData) {
  event.preventDefault();

  const url = window.routes.cart_add_url;
  await manageAnamCartOperations(url, event, serializedData);
}

export {getCart, addToCart, updateItem, changeItem, removeItem, addAnamToCart};
